import Api from "./Base";
import settings from "../clientappsettings.json";

export class HelpCentreApi extends Api {
  baseUrl = settings.BUYERS_URL;
  requestUrl = `/Buyers/HelpCentreInfo`;
  method = "GET";
  headers = {
    Authorization: `Bearer ${this.getCredentials()}`
  };

  formatResponseData(response) {
    return response;
  }
}
